module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "garage"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('h2', {
    staticClass: "page_title"
  }, [_vm._v("\n      My Garage\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link button",
    class: {
      active: _vm.isTabActive(_vm.purchasedTabName)
    },
    style: ([
      _vm.isTabActive(_vm.purchasedTabName) ?
      _vm.borderStyle :
      {
        'background-color': '#fff',
        color: '#2196F3'
      } ]),
    attrs: {
      "href": '#' + _vm.purchasedTabName
    },
    on: {
      "click": function($event) {
        return _vm.onTab(_vm.purchasedTabName)
      },
      "openModal": function($event) {
        return _vm.openModal($event)
      }
    }
  }, [_vm._v("Purchased")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    class: {
      active: _vm.isTabActive(_vm.favoritesTabName)
    },
    style: ([
      _vm.isTabActive(_vm.favoritesTabName) ?
      _vm.borderStyle :
      {
        'background-color': '#fff',
        color: '#2196F3'
      } ]),
    attrs: {
      "href": '#' + _vm.favoritesTabName
    },
    on: {
      "click": function($event) {
        return _vm.onTab(_vm.favoritesTabName)
      }
    }
  }, [_vm._v("My Favorites")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-wrap"
  }, [_c('div', {
    staticClass: "tabs",
    attrs: {
      "id": "garageTabs"
    }
  }, [_c('div', {
    staticClass: "tab",
    class: {
      active: _vm.isTabActive(_vm.purchasedTabName)
    },
    attrs: {
      "id": _vm.purchasedTabName
    }
  }, [_c('garage-vehicles-list', {
    attrs: {
      "vehicles": _vm.purchasedVehicles,
      "customization": _vm.customization
    },
    on: {
      "scheduleService": function($event) {
        return _vm.openModal($event)
      },
      "whyMyCarWorth": function($event) {
        return _vm.openModal($event)
      },
      "onVehicleClick": _vm.onVehicleClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.isTabActive(_vm.favoritesTabName)
    },
    attrs: {
      "id": _vm.favoritesTabName
    }
  }, [_c('garage-favorites-list', {
    attrs: {
      "vehicles": _vm.favoritesVehicles,
      "customization": _vm.customization,
      "disableFavorite": _vm.disableFavorite
    },
    on: {
      "toggleFavorite": function($event) {
        return _vm.onToggleVehicle($event)
      },
      "onVehicleClick": _vm.onVehicleClick
    }
  })], 1)])])]), _vm._v(" "), _c('f7-popup', {
    ref: "modal"
  }, [_c('iframe', {
    attrs: {
      "id": "widget",
      "src": _vm.widgetUrl,
      "frameborder": "0"
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-555f77f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555f77f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/garage/garage.vue
// module id = 778
// module chunks = 0